import axios from "axios";
import API_BASE_URL from '../../config';

export const DeleteFavoriteUserService = async (token, userId, taskId) => {
  try {
    if (!token) {
      throw new Error("No token available");
    }

    const response = await axios.delete(`${API_BASE_URL}api/delete-favorite-user/`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      data: {
        user_id: userId,
        task_id: taskId
      }
    });

    return response.data;
  } catch (error) {
    console.error('Error al eliminar favorito:', error.response ? error.response.data : error.message);
    throw error;
  }
};
